<template>
  <div class="PublicityDetail5">    
    <h3>智慧防范，金融有道 —— 经典故事新解助力消费者权益保护</h3>
    <div>在这个信息爆炸、金融产品日益丰富的时代，金融消费者的权益保护显得尤为重要。广东智选保险代理有限公司，作为广东省保险行业协会的会员单位，我们深知自身肩负的责任与使命。在本次的“消费者权益保护教育宣传”活动中，我们将秉承“金融消保在身边 保障权益防风险”的主题口号，积极履行消费者权益保护和教育宣传的主体责任，充分发挥我们的主动性和创造性。</div>
    <br/>
    <div>为更好深入贯彻习近平新时代中国特色社会主义思想，落实党的二十大、二十届二中全会和中央金融工作会议精神，以满足人民群众对美好生活的向往为根本出发点。我们将通过线上渠道，教育引导保险消费者增强守法履职意识和依法维权能力，优化消费环境，为推动保险业的高质量发展贡献力量。</div>
    <br/>
    <div>我们将在官网和公众号上同步发布由中国人寿广东省分公司精心制作的两条趣味教育视频：《三国演义》新编之诸葛军师破解非法集资骗局和《水浒传》新编之武大郎险掉“代理理赔”陷阱。这两部视频以经典文学作品为创意基础，巧妙融入金融消费者权益保护的教育内容，旨在提高公众对金融风险的认识，以期通过数字科技手段，提升金融宣传的广度和深度。</div>
    <br/>
    <h3>《三国演义》新编之诸葛军师破解非法集资骗局</h3>
    <video controls>
      <source :src="`${BASE_URL}videos/video1.mp4`" type="video/mp4" />
    </video>
    <br/>
    <h3>《水浒传》新编之武大郎险掉“代理理赔”陷阱</h3>
    <video controls>
      <source :src="`${BASE_URL}videos/video2.mp4`" type="video/mp4" />
    </video>
    <br/>
    <div>教育与保护，并行不悖。我们的目标是让每一位保险消费者都成为自己权益的第一道守门人，懂得如何运用法律武器来维护自身合法权益。广东智选保险代理有限公司，深知自身肩负的责任与使命。为此，我们注意每一个声音，我们响应每一种需求，因为我们知道，提高一人金融知识，保障一家人民安全，体现巨大保险力量的，不仅仅是金钱回报，更是风险防护之盾，也是思想进步之翼。让我们携手在金融消费者权益保护的征途上，让“金融消保在身边，保障权益防风险”成为每一个人的共同信念。</div>
    <br/>
    <div>现代技术的日新月异提供了多种可能性，数字科技手段的融入，不仅能提升金融宣传的广度，更能加深服务的渗透，从而形成广泛覆盖，可以让金融教育像阳光与空气一样存在——无声而又出奇有效。期待在新时代的征途上，我们的共同努力能构建起一个普惠、包容、务实而又安全的金融环境，使之真正融入千家万户。</div>
  </div>
</template>

<script>
export default {
  name: 'PublicityDetail5',
  data() {
    return {
      BASE_URL: process.env.BASE_URL
    };
  },
};
</script>

<style scoped lang="less">
.PublicityDetail5 {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h3 {
    font-weight: bold;
    font-size: 28px;
    line-height: 52px;
    align-self: center;
  }

  .title {
    font-weight: bold;
    font-size: 24px;
    line-height: 45px;
  }

  .subtitle {
    font-size: 20px;
    line-height: 40px;
    font-weight: 500;
    text-indent: 2em;

    &.no-indent {
      text-indent: unset;
    }
  }

  div {
    text-align: left;
  }

  p {
    text-indent: 2em;
    margin: 15px 0 0;
    text-align: left;
    margin-block-end: 0;
    margin-block-start: 0;
  }

  img {
    width: 50%;
    margin-top: 30px;
    align-self: center;
  }

  p + img,
  .subtitle + img {
    margin-left: 2em;
  }

  img + p {
    margin-top: 15px;
  }

  img + .title,
  p + .title {
    margin-top: 60px;
  }

  .title + .subtitle,
  img + .subtitle {
    margin-top: 15px;
  }

  p + .subtitle {
    margin-top: 45px;
  }

  video {
    width: 80%;
    margin: 0 auto;
  }
}
</style>
